import React, { useMemo } from 'react';
import { WrapItem, Wrap } from '@chakra-ui/react';
import { Filtering } from '../../QOrganisms';
import { QActiveFilter } from './ActiveFilter';

/**
 * Renders active filters in a row and handles their dismissal.
 *
 * Requires a user provider and filter provider.
 */
export const QActiveFiltersView: React.VFC = () => {
  const { definitions, filters, removeFilter, setFilters } =
    Filtering.useFiltering();

  const items = useMemo((): React.ReactNode => {
    const removeArrayItem = (key: string, value: unknown) => {
      const updatedArray = (filters[key].value as unknown[]).filter(
        (v) => v !== value,
      );

      setFilters({
        [key]: updatedArray.length > 0 ? updatedArray : null,
      });
    };

    return Object.entries(filters).map(([key, filter]) => {
      if (Array.isArray(filter.value)) {
        return filter.value.map(
          (value, i): React.ReactElement => (
            <WrapItem key={`${key}-${i}`}>
              <QActiveFilter
                filter={{ ...filter, value }}
                onRemove={() => removeArrayItem(key, value)}
                render={definitions[key]?.activeRender}
              />
            </WrapItem>
          ),
        );
      }
      return (
        <WrapItem key={key}>
          <QActiveFilter
            filter={filter}
            onRemove={() => removeFilter(key)}
            render={definitions[key]?.activeRender}
          />
        </WrapItem>
      );
    });
  }, [definitions, filters, removeFilter]);

  return (
    <Wrap direction="row" spacing="8px">
      {items}
    </Wrap>
  );
};
